import * as React from 'react';
import BarLoader from 'react-spinners/BarLoader';
import ProgressBar from 'react-bootstrap/ProgressBar';
import uuid from 'react-uuid';

export interface LoaderProps {
    /** Title to display when loading */
    title?: string,
    /** Shows title on the bottom of loader */
    bottom?: boolean,
    classNames?: string,
    /** How long until component should time out */
    messageTimeout?: number,
    /** Custom timeout message */
    timeoutMessage?: string,
    /** A key value pair where the key is seconds passed and value is the message to show at that time */
    messages?: { [key: number]: string },
    /** Type of loader to render. */
    type?: "infinite" | "progress" | "messages",
    /** If type is equal to progress, this will be a number 0-100 indicating progress */
    progress?: number,
    label?: string,
    styles?: Object,
    // A key value pair key being seconds passed and value being displayed message
    id?: string
}

const Loader: React.FunctionComponent<LoaderProps> = (props: LoaderProps) => {
    const [title, setTitle] = React.useState(props.title);

    React.useEffect(() => {
        if (props.type === "infinite") {
            // Sets up a timer for 5 seconds and changes loading message 
            // after set time
            let timer = setTimeout(() => {
                setTitle(props.timeoutMessage);
            }, props.messageTimeout);
            let mInterval: any = null;
            if (props.messages && props.messageTimeout) {
                let mt: any = props.messageTimeout;
                let m: any = props.messages;
                let pt: number = 0;
                mInterval = setInterval(() => {
                    pt += 1;
                    if (pt >= (mt / 1000 || 20000)) {
                        setTitle(props.timeoutMessage);
                    }
                    if (m[pt]) {
                        setTitle(m[pt]);
                    }
                }, 1000)
            }
            return () => {
                clearTimeout(timer);
                if (mInterval) {
                    clearInterval(mInterval);
                }
                mInterval && clearInterval(mInterval);
            }
        }
    }, [props.messageTimeout, props.timeoutMessage, props.messages, props.type])

    if (props.type === "infinite") {
        return (
            <div id={props.id ? props.id : uuid()} style={props.styles} className={`barLoaderPortal d-flex flex-column ${props.classNames || "mt-5"}`}>
                {props.title && !props.bottom ? <p>{title}</p> : null}
                <BarLoader height="5px" width="200px" color="#095399" loading={true} />
                {props.title && props.bottom ? <p>{title}</p> : null}
            </div>
        );
    }
    //- Progress
    else {
        return (
            <div id={props.id ? props.id : uuid()} style={props.styles} className={`barLoaderPortal d-flex flex-column ${props.classNames || "mt-5"}`}>
                {props.title && !props.bottom ? <p>{title}</p> : null}
                <ProgressBar now={props.progress} label={props.label} className="progress-loader" />
                {props.title && props.bottom ? <p>{title}</p> : null}
            </div>
        );
    }
}

Loader.defaultProps = {
    title: "",
    messageTimeout: 20000,
    timeoutMessage: "Still Working on it...",
    messages: {},
    type: "infinite",
    label: "",
    progress: 0,
    styles: {}
};

export default Loader;